import React from 'react';
import Translate from 'react-translate-component';

import classes from './TransCap.module.css';

const transCap = props => {
    return <Translate content={props.text} className={classes.TransCap} />
}

export default transCap;